<template>
  <ngc-modal
    :open="showModal"
    variant="decide"
    :title.prop="'Discard changes'"
    data-testid="discard-changes-modal"
    @close="cancel"
  >
    <span>Your edits to this page have not been saved.</span>

    <!-- ngc-modal has no secondary-action-text API — its `decide` footer
         hardcodes "Cancel". The built-in buttons are fallback content of the
         footer slot, so filling the slot replaces them and lets us label both. -->
    <div
      slot="footer"
      class="discard-actions"
    >
      <ngc-button
        variant="secondary"
        data-testid="discard-changes-keep-editing"
        @click="cancel"
      >
        Keep Editing
      </ngc-button>
      <ngc-button
        variant="primary"
        data-testid="discard-changes-confirm"
        @click="handleDiscardChanges"
      >
        Discard Changes
      </ngc-button>
    </div>
  </ngc-modal>
</template>

<script>

export default {
  name: 'DiscardChangesModal',
  props: {
    toggleModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    toggleModal () {
      this.showModal = this.toggleModal
    }
  },
  methods: {
    handleDiscardChanges () {
      this.$emit('close')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

/* Mirrors Gator's own .gator-modal-action-buttons so the slotted footer keeps
   the stock spacing and alignment. */
.discard-actions {
  display: flex;
  gap: var(--spacing-5);
  margin-left: auto;
}

@media (max-width: 600px) {
  .discard-actions {
    flex-direction: column-reverse;
    width: 100%;
    margin-left: 0;
  }

  .discard-actions ngc-button {
    --ngc-button-width: 100%;
  }
}

</style>
